/**
 * loginInfo 返回 401 时，根据 URL 中的 token 跳转登录并回跳原页面
 */

/** 从 search 与 hash 路由 query 中读取 token */
export function getUrlToken() {
  const search = new URLSearchParams(window.location.search);
  const fromSearch = search.get('token');
  if (fromSearch) return fromSearch;

  const hash = window.location.hash || '';
  const qIndex = hash.indexOf('?');
  if (qIndex === -1) return null;
  const hashQuery = new URLSearchParams(hash.slice(qIndex + 1));
  return hashQuery.get('token');
}

/** 从 query 对象中移除 token，保留其余参数 */
export function omitTokenFromQuery(query = {}) {
  const next = { ...query };
  delete next.token;
  return next;
}

/** 生成去掉 token 后的当前页完整地址，用于登录成功后回跳 */
export function buildRedirectUrlWithoutToken() {
  const { origin, pathname, search, hash } = window.location;
  const searchParams = new URLSearchParams(search);
  searchParams.delete('token');
  const searchStr = searchParams.toString();
  const searchPart = searchStr ? `?${searchStr}` : '';

  if (!hash || hash.indexOf('?') === -1) {
    return `${origin}${pathname}${searchPart}${hash}`;
  }

  const hashPath = hash.slice(0, hash.indexOf('?'));
  const hashQuery = new URLSearchParams(hash.slice(hash.indexOf('?') + 1));
  hashQuery.delete('token');
  const hashQueryStr = hashQuery.toString();
  const hashPart = hashQueryStr ? `${hashPath}?${hashQueryStr}` : hashPath;
  return `${origin}${pathname}${searchPart}${hashPart}`;
}

export function saveRedirectUrl() {
  sessionStorage.setItem('redirectUrl', buildRedirectUrlWithoutToken());
}

let routerModulePromise = null;

function getRouter() {
  if (!routerModulePromise) {
    routerModulePromise = import('@/router').then((m) => m.default);
  }
  return routerModulePromise;
}

/** 通过 Vue Router 跳转登录页（避免 hash replace 不触发路由） */
export function redirectToLoginWithToken(token) {
  saveRedirectUrl();
  const query = { token };
  return getRouter().then((router) => {
    const { name, query: currentQuery } = router.currentRoute;
    if (name === 'login' && currentQuery.token === token) {
      return router.replace({ name: 'login', query: { ...query, _r: String(Date.now()) } });
    }
    return router.replace({ name: 'login', query });
  });
}

export function isUnauthorizedResponse(response) {
  return (
    response.status === 401 ||
    response.data?.code === 401
  );
}

/**
 * loginInfo 401 且 URL 带 token：跳转登录页
 * @returns {boolean} 是否已处理（已跳转登录）
 */
export function tryHandleLoginInfo401(response) {
  if (!isUnauthorizedResponse(response)) {
    return false;
  }
  const token = getUrlToken();
  if (!token) {
    return false;
  }
  redirectToLoginWithToken(token);
  return true;
}
